import type { DescMethodUnary } from "@bufbuild/protobuf";

/**
 * Services whose mutations move an `InventoryService` count badge. By service, not method: a
 * miss shows a wrong number. By name, not descriptor: this reaches nearly every page chunk.
 */
export const SERVICES_AFFECTING_NAVBAR_COUNTS: ReadonlySet<string> = new Set([
  "chalk.scalinggroup.v1.ScalingGroupManagerService",
  "chalk.modeldeployment.v1.ModelDeploymentService",
  "chalk.externalfunctioncatalog.v1.ExternalFunctionCatalogService",
  "chalk.sandbox.v1.SandboxService",
  "chalk.sandbox.v2.SandboxService",
  "chalk.sandbox.v2.SandboxSnapshotService",
  "chalk.container.v1.ContainerService", // sandboxes
  "chalk.notebook.v1.NotebookDocumentService",
  "chalk.server.v1.WebhookService",
  "chalk.server.v1.IntegrationsService",
  "chalk.server.v1.EnvironmentSecretsService",
  "chalk.server.v1.OfflineStoreConnectionService",
  "chalk.agent.v1.AiProviderConnectionService",
  "chalk.server.v1.ModelRegistryService",
  "chalk.server.v1.PromptService",
  // Access tokens, projects, and the inline environment configs behind online stores /
  // vector DBs / config variables (UpdateEnvironment).
  "chalk.server.v1.TeamService",
  "chalk.server.v1.CloudAccountCredentialsService",
  // Clusters, registries, VPCs, storage, and the environment-storage bindings behind buckets.
  "chalk.server.v1.CloudComponentsService",
]);

export const mutationAffectsNavbarCounts = (method: DescMethodUnary): boolean =>
  SERVICES_AFFECTING_NAVBAR_COUNTS.has(method.parent.typeName);
